// list ids form validations documents
export const docId = {
  trust: 1,
  no_objection: 2,
  legal_status: 3,
  land_purchase: 4,
  environment: 5,
  building_license: 6,
  previous_mitur: 7,
  final_confotur: 8,
  aprocovici: 9,
  company_assembly_act: 10,
  enlarged_due_diligence: 11,
  credit_bureau: 12,
  company_rnc: 13,
  master_plan: 14,
  trust_transferred_title: 15,
  trust_transferred_title_builder: 16,
  commercial_register: 17,
  land_transfer_tax: 18,
  deposit_at_town_hall: 19,
  land_movement: 20,
  construction_company_resume: 21,
  temporal_legal_status: 22,
  acoprovi: 23,
  file_title_property: 24,
  property_contract: 25
};

export type IValidationDocuments = {
  [key: number]: {
    id: number;
    status: string;
    msg: string;
    disabled: boolean;
    alert: boolean;
    name: string;
  };
};

export const formValidationDetail: IValidationDocuments = {};

for (let i = 1; i <= 25; i++) {
  formValidationDetail[i] = {
    id: i,
    status: "",
    msg: "",
    disabled: false,
    alert: false,
    name: ""
  };
}
export type IValidationDocumentsObject = {
  [key in keyof typeof docId]: {
    id: number;
    status: "approved" | "rejected" | "warning";
    msg: string;
    disabled: boolean;
    alert: boolean;
    name: string;
  };
};

export const baseState = Object.keys(docId).reduce(
  (acc, key) => ({
    ...acc,
    [key]: {
      // @ts-ignore
      id: docId[key],
      status: "",
      msg: "",
      disabled: false,
      alert: false,
      name: ""
    }
  }),
  {} as IValidationDocumentsObject
);
